import { MutationTree } from 'vuex'
import { PointOfInterest } from './types'
import { PointsOfInterest } from '@/helpers/objects/PointsOfInterest'

export const mutations: MutationTree<PointOfInterest> = {
  getPointsOfInterest(state, point: PointsOfInterest) {
    state.filterPointsOfInterest.push(point)
  },
  setPointsOfInterest(state, points) {
    state.filterPoints = points
  },
  resetFilterTagsState(state) {
    state.filterPoints = state.filterPointsOfInterest
  },
  setGeocodeResult(state, { geocodeResult }) {
    state.geocodeResult = geocodeResult
  },
  setPointOfInterestGeoCoordinates(state, { lat, lng }) {
    state.pointOfInterestGeoCoordinates = { lat, lng }
  }
}
